import React, { useEffect, useState } from "react";

const CustomTradeDate = ({ value = "", onChange, idPrefix = "trade", disabled = false }) => {
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  useEffect(() => {
    const [dd = "", mm = "", yyyy = ""] = value.split("-");

    setDay(dd);
    setMonth(mm);
    setYear(yyyy);
  }, [value]);

  const emitDate = (d, m, y) => {
    const date =
      d +
      (m || y ? "-" : "") +
      m +
      (y ? "-" : "") +
      y;

    onChange(date);
  };

  const handleDay = (e) => {
    let val = e.target.value.replace(/\D/g, "").slice(0, 2);

    if (Number(val) > 31) {
      val = "31";
    }

    setDay(val);
    emitDate(val, month, year);

    if (val.length === 2) {
      document.getElementById(`${idPrefix}-month`)?.focus();
      // document.getElementById("trade-month")?.focus();
    }
  };

  const handleMonth = (e) => {
    let val = e.target.value.replace(/\D/g, "").slice(0, 2);

    if (Number(val) > 12) {
      val = "12";
    }

    setMonth(val);
    emitDate(day, val, year);

    if (val.length === 2) {
      document.getElementById(`${idPrefix}-year`)?.focus();
      // document.getElementById("trade-year")?.focus();
    }
  };

  const handleYear = (e) => {
  let val = e.target.value.replace(/\D/g, "").slice(0, 4);

  if (val.length === 1 && !["1", "2"].includes(val)) {
    return;
  }

  if (val.length === 2) {
    if (val[0] === "1" && val[1] < "7") {
      return; // prevents 16xx, 15xx etc.
    }
  }

  if (val.length === 4) {
    const yearNum = Number(val);
    const currentYear = new Date().getFullYear();

    if (yearNum < 1700) {
      val = "1700";
    }

    if (idPrefix !== "effectiveDate" && yearNum > currentYear) {
      val = String(currentYear);
    }
  }

  setYear(val);
  emitDate(day, month, val);
};

  return (
    <div className="trade-date-wrapper">
      <input
        type="text"
        value={day}
        maxLength={2}
        placeholder="DD"
        onChange={handleDay}
        disabled={disabled}
      />

      <span>-</span>

      <input
        // id="trade-month"
        id={`${idPrefix}-month`}
        type="text"
        value={month}
        maxLength={2}
        placeholder="MM"
        onChange={handleMonth}
        disabled={disabled}
      />

      <span>-</span>

      <input
        // id="trade-year"
        id={`${idPrefix}-year`}
        type="text"
        value={year}
        maxLength={4}
        placeholder="YYYY"
        onChange={handleYear}
        disabled={disabled}
      />
    </div>
  );
};

export default CustomTradeDate;